import {Button, Col, Descriptions, Row, Tooltip} from "antd";
import React, {Fragment, useState} from "react";
import {BillingUpdateModal} from "../modals/billingUpdateModal/BillingUpdateModal";
import {EditOutlined} from "@ant-design/icons";

export const SubcompanyBilling = ({subcompanyId, subCompany, refetch, ...props}) => {
    const [updateBillingModalVisibility, setUpdateBillingModalVisibility] = useState(false);

    const closeModals = async (needRefresh = false) => {
        setUpdateBillingModalVisibility(false);
        if (needRefresh) {
            refetch();
        }
    };

    const handleUpdateBilling = () => {
        setUpdateBillingModalVisibility(true);
    };

    return (
        <Fragment>
            <Col {...props}>
                <Row
                    type="flex"
                    justify="space-between"
                    style={{
                        fontSize: "16px",
                        fontWeight: "700",
                        marginTop: "30px",
                        marginBottom: "20px"
                    }}
                >
                    Cari Bilgileri
                    <Row type="flex" justify="end" gutter={4}>
                        <Tooltip placement="topRight" title={"Cari Bilgileri Düzenle"}>
                            <Col>
                                <Button
                                    type="primary"
                                    icon={<EditOutlined />}
                                    onClick={handleUpdateBilling}
                                />
                            </Col>
                        </Tooltip>
                    </Row>
                </Row>
                <Row>
                    <Col span={24}>
                        <Descriptions columns={2} bordered>
                            <Descriptions.Item span={2} label={"Ticari Ünvan"}>
                                {subCompany?.bill?.commercialTitle ?? "-"}
                            </Descriptions.Item>
                            <Descriptions.Item span={2} label={"Cari Kodu"}>
                                {subCompany?.cariCode ?? "-"}
                            </Descriptions.Item>
                            <Descriptions.Item span={2} label={"Para Transfer Kodu"}>
                                {subCompany?.expCode ?? "-"}
                            </Descriptions.Item>
                            <Descriptions.Item span={2} label={"Proje Kodu"}>
                                {subCompany?.projectCode ?? "-"}
                            </Descriptions.Item>
                            <Descriptions.Item span={2} label={"Vergi Dairesi"}>
                                {subCompany?.bill?.registeredTaxOffice ?? "-"}
                            </Descriptions.Item>
                            <Descriptions.Item span={2} label={"Vergi Numarası"}>
                                {subCompany?.bill?.taxNumber ?? "-"}
                            </Descriptions.Item>
                            <Descriptions.Item span={2} label={"Telefon Numarası"}>
                                {subCompany?.authorizedPhone ?? "-"}
                            </Descriptions.Item>
                            <Descriptions.Item span={2} label={"Fatura Bilgisi"}>
                                {subCompany?.bill?.billInformation ?? "-"}
                            </Descriptions.Item>
                        </Descriptions>
                    </Col>
                </Row>
            </Col>

            <BillingUpdateModal
                subCompany={subCompany}
                visibility={updateBillingModalVisibility}
                onCancel={closeModals}
            />
        </Fragment>
    );
};
